/* eslint-disable react/prop-types */
import React from 'react';
import Modal from 'react-modal';
import styles from './CancelModal.module.css';

const CancelModal = ({ isOpen, closeModal }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      className={`modal-content w-100`}
      overlayClassName={'modal-overlay'}
      contentLabel="Cancel Modal"
    >
      <div className="d-flex flex-column">
        <div className={styles.modalTop}>
          <div className={styles.modalClose} onClick={closeModal}></div>
        </div>
        {/* <div className={`w-100 text-center ${styles.modalTitle}`}>DİKKAT</div> */}
        <div className={`${styles.modalDescription} mt-2`}>
          Bu ödeme linkini iptal etmek ve ödeme sürecini sonlandırmak istiyor musunuz?
        </div>
        {/* <div className={`${styles.modalDescription} mt-3`}>
          Bu işlemi onaylıyor musunuz?
        </div> */}

        <div className={`${styles.actionsButtons} mt-4`}>
          <button className={`${styles.modalDescription} ${styles.acceptBtn} w-50`}>Evet</button>
          <button
            className={`${styles.modalDescription} ${styles.cancelBtn} w-50`}
            onClick={closeModal}
          >
            Geri
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CancelModal;
